import { useSmartProp } from '@smartfire/js-block-engine';
import { PanelBody, PanelRow, RangeControl } from '@wordpress/components';

const Inspector = () => {
    const [height, setHeight] = useSmartProp('height');
    const [heightLaptop, setHeightLaptop] = useSmartProp('laptopHeight');
    const [heightTablet, setHeightTablet] = useSmartProp('tabletHeight');
    const [heightMobile, setHeightMobile] = useSmartProp('mobileHeight');

    const HEIGHT_LIMIT = 150;

    return (
        <>
            <PanelBody title={'Hauteur'}>
                <PanelRow>
                    <RangeControl
                        label={'Sur un écran'}
                        value={height}
                        onChange={setHeight}
                        min={0}
                        max={HEIGHT_LIMIT}
                    />
                </PanelRow>
                <PanelRow>
                    <RangeControl
                        label={'Sur un ordinateur'}
                        value={heightLaptop}
                        onChange={setHeightLaptop}
                        min={0}
                        max={HEIGHT_LIMIT}
                    />
                </PanelRow>
                <PanelRow>
                    <RangeControl
                        label={'Sur une tablette'}
                        value={heightTablet}
                        onChange={setHeightTablet}
                        min={0}
                        max={HEIGHT_LIMIT}
                    />
                </PanelRow>
                <PanelRow>
                    <RangeControl
                        label={'Sur un téléphone'}
                        value={heightMobile}
                        onChange={setHeightMobile}
                        min={0}
                        max={HEIGHT_LIMIT}
                    />
                </PanelRow>
            </PanelBody>
        </>
    );
};

export default Inspector;
